import styled from '@emotion/styled';
import Link from '../../components/Link/Link';
import rem from '../../utils/rem/rem';

export const StyledHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.gray200};
  padding: ${rem(24)} ${rem(32)} ${rem(32)} ${rem(32)};
  margin-bottom: ${rem(32)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLink = styled(Link)`
  width: max-content;
  color: ${({ theme }) => theme.colors.darkBlue};
`;

export const Title = styled.h1`
  font-family: 'Pizza Hut';
  font-size: ${rem(30)};
  margin-top: ${rem(8)};
`;

export const StepTrackerWrapper = styled.div`
  position: relative;
  top: ${rem(16)};
`;
